//Get all category for list
const CATEGORY_TICKET_DATA = {
  CATEGORY_TICKET_DATA_LOAD: "CATEGORY_TICKET_DATA_LOAD",
  CATEGORY_TICKET_DATA_SUCCESS: "CATEGORY_TICKET_DATA_SUCCESS",
  CATEGORY_TICKET_DATA_FAIL: "CATEGORY_TICKET_DATA_FAIL",
};
const CATEGORY_TICKET_DATA_GET_API = "tickets/categories/config";

//Get all category
const CATEGORY_SUBCATEGORY_DATA = {
  CATEGORY_SUBCATEGORY_DATA_LOAD: "CATEGORY_SUBCATEGORY_DATA_LOAD",
  CATEGORY_SUBCATEGORY_DATA_SUCCESS: "CATEGORY_SUBCATEGORY_DATA_SUCCESS",
  CATEGORY_SUBCATEGORY_DATA_FAIL: "CATEGORY_SUBCATEGORY_DATA_FAIL",
};
const CATEGORY_SUBCATEGORY_DATA_GET_API = "tickets/categories/with-subcategories";

//Get all category
const CATEGORY_SUBCATEGORY_CONFIG_DATA = {
  CATEGORY_SUBCATEGORY_CONFIG_DATA_LOAD: "CATEGORY_SUBCATEGORY_CONFIG_DATA_LOAD",
  CATEGORY_SUBCATEGORY_CONFIG_DATA_SUCCESS: "CATEGORY_SUBCATEGORY_CONFIG_DATA_SUCCESS",
  CATEGORY_SUBCATEGORY_CONFIG_DATA_FAIL: "CATEGORY_SUBCATEGORY_CONFIG_DATA_FAIL",
};
const CATEGORY_SUBCATEGORY_CONFIG_DATA_GET_API = "tickets/categories/with-subcategories-and-config";

//Get cate by id
const CATEGORY_GET_DATA = {
  CATEGORY_GET_DATA_LOAD: "CATEGORY_GET_DATA_LOAD",
  CATEGORY_GET_DATA_SUCCESS: "CATEGORY_GET_DATA_SUCCESS",
  CATEGORY_GET_DATA_FAIL: "CATEGORY_GET_DATA_FAIL",
};
const CATEGORY_GET_DETAIL_API = "tickets/categories/config/";

// Add cate
const CATEGORY_FORM_ADD_DATA = {
  CATEGORY_FORM_ADD_DATA_LOAD: "CATEGORY_FORM_ADD_DATA_LOAD",
  CATEGORY_FORM_ADD_DATA_SUCCESS: "CATEGORY_FORM_ADD_DATA_SUCCESS",
  CATEGORY_FORM_ADD_DATA_FAIL: "CATEGORY_FORM_ADD_DATA_FAIL",
};
const CATEGORY_FORM_POST_API = "tickets/categories/config";

// Update 
const CATEGORY_UPDATE_DATA = {
  CATEGORY_UPDATE_DATA_LOAD: "CATEGORY_UPDATE_DATA_LOAD",
  CATEGORY_UPDATE_DATA_SUCCESS: "CATEGORY_UPDATE_DATA_SUCCESS",
  CATEGORY_UPDATE_DATA_FAIL: "CATEGORY_UPDATE_DATA_FAIL",
  CATEGORY_UPDATE_DATA_RESET: "CATEGORY_UPDATE_DATA_RESET"
};

const CATEGORY_POST_API = "tickets/categories/config/";

// Delete cate
const CATEGORY_DELETE_DATA = {
  CATEGORY_DELETE_LOAD: "CATEGORY_DELETE_LOAD",
  CATEGORY_DELETE_SUCCESS: "CATEGORY_DELETE_SUCCESS",
  CATEGORY_DELETE_FAIL: "CATEGORY_DELETE_FAIL",
};
const CATEGORY_DELETE_API = "tickets/categories/config/toggle-status/";

//Get all category for list
const CATEGORY_GET_ALL_DATA = {
  CATEGORY_GET_ALL_DATA_LOAD: "CATEGORY_GET_ALL_DATA_LOAD",
  CATEGORY_GET_ALL_DATA_SUCCESS: "CATEGORY_GET_ALL_DATA_SUCCESS",
  CATEGORY_GET_ALL_DATA_FAIL: "CATEGORY_GET_ALL_DATA_FAIL",
};
const CATEGORY_GET_ALL_DATA_API = "tickets/categories/all";
// Update ALL category or subcategory
const CATEGORY_UPDATE_ALL_DATA = {
  CATEGORY_UPDATE_ALL_DATA_LOAD: "CATEGORY_UPDATE_ALL_DATA_LOAD",
  CATEGORY_UPDATE_ALL_DATA_SUCCESS: "CATEGORY_UPDATE_ALL_DATA_SUCCESS",
  CATEGORY_UPDATE_ALL_DATA_FAIL: "CATEGORY_UPDATE_ALL_DATA_FAIL",
};
const CATEGORY_UPDATE_ALL_API = "tickets/categories/";  

// Delete ALL category or subcategory
const CATEGORY_DELETE_ALL_DATA = {
  CATEGORY_DELETE_ALL_LOAD: "CATEGORY_DELETE_ALL_LOAD",
  CATEGORY_DELETE_ALL_SUCCESS: "CATEGORY_DELETE_ALL_SUCCESS",
  CATEGORY_DELETE_ALL_FAIL: "CATEGORY_DELETE_ALL_FAIL",
};
const CATEGORY_DELETE_ALL_API = "tickets/categories/";  



export{
  
  CATEGORY_TICKET_DATA,
  CATEGORY_TICKET_DATA_GET_API,
  CATEGORY_SUBCATEGORY_DATA,
  CATEGORY_SUBCATEGORY_DATA_GET_API,
  CATEGORY_SUBCATEGORY_CONFIG_DATA,
  CATEGORY_SUBCATEGORY_CONFIG_DATA_GET_API,
  CATEGORY_GET_DATA,
  CATEGORY_GET_DETAIL_API,
  CATEGORY_FORM_ADD_DATA,
  CATEGORY_FORM_POST_API,
  CATEGORY_UPDATE_DATA,
  CATEGORY_POST_API, 
  CATEGORY_DELETE_DATA,
  CATEGORY_DELETE_API,  
  CATEGORY_GET_ALL_DATA,
  CATEGORY_GET_ALL_DATA_API,
  CATEGORY_UPDATE_ALL_DATA,
  CATEGORY_UPDATE_ALL_API,
  CATEGORY_DELETE_ALL_DATA,
  CATEGORY_DELETE_ALL_API,
}